"use client";
import { LoadingButton } from "@mui/lab";
import { Box, CircularProgress } from "@mui/material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";

const LoadingButtonUI: React.FC<{
  isSubmitLoading: boolean;
}> = ({ isSubmitLoading }) => {
  return (
    <LoadingButton
      variant="contained"
      type="submit"
      disableElevation
      loadingPosition="start"
      disabled={isSubmitLoading}
      sx={{
        height: { xs: "40px", sm: "40px" },
        p: { xs: "8px 17px 6px 12px", md: "6px 17px 6px 12px" },
        mt: "0px",
        minWidth: "150px",
        width: "fit-content",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px",
        fontWeight: 500,
        background: "linear-gradient(90deg, #332cff 0%, #083a5f 100%)",
        textAlign: "left",
        justifyContent: "flex-start",
        borderRadius: "10px",
        boxShadow: {
          xs: "0px 0px 8px rgba(0,0,0,0.2)",
          md: "none",
        },
        "&.Mui-disabled": {
          bgcolor: "#1B4E89",
          color: "#fff",
          ".get_quote_icon": {
            border: "2px solid #fff",
          },
        },
      }}
    >
      <Box sx={{ mt: { xs: "0px", md: "2px" } }}>
        {isSubmitLoading ? "Sending..." : "Get quote"}
      </Box>
      <Box
        className="get_quote_icon"
        sx={{
          height: { xs: "44px", sm: "44px" },
          width: { xs: "44px", sm: "44px" },
          mb: "2px",
          background: "linear-gradient(90deg, #083a5f 0%, #332cff 100%)",
          border: "2px solid #fff",
          borderRadius: "30px",
          display: "grid",

          placeItems: "center",
          position: "absolute",
          top: { xs: "-2px", sm: "-2px" },
          right: { xs: "12px", sm: "12px", md: "10px" },
          boxShadow: "0px 0px 9px 6px #332cff4f",
        }}
      >
        {isSubmitLoading ? (
          <Box sx={{ mt: "8px" }}>
            <CircularProgress color="secondary" size={20} sx={{ color: "#fff" }} />
          </Box>
        ) : (
          <SendRoundedIcon
            sx={{
              height: { xs: "23px", sm: "23px" },
              width: { xs: "23px", sm: "23px" },
              mb: { xs: "0px", sm: "0px" },
              ml: { xs: "4px", sm: "4px" },
            }}
          />
        )}
      </Box>
    </LoadingButton>
  );
};

export default LoadingButtonUI;
